import { Button, CaptureClicksRichText } from '@/features/shared';
import { MuiTypography } from '@/features/shared/material-ui';
import clsx from 'clsx';
import React, { memo, useMemo } from 'react';
import { HeaderContentProps } from './HeaderContent.interface';
import useStyles from './HeaderContent.styles';

const HeaderContent = ({
  logo,
  headline,
  shortDescription,
  primaryButton,
  downloadLink,
  includeDownload,
  downloadIcon,
  downloadText,
  theme,
}: HeaderContentProps) => {
  const classes = useStyles({});
  const hasLogo = useMemo(() => logo && logo.original, [logo]);
  const hasDownloadLink = useMemo(
    () => includeDownload && downloadLink,
    [downloadLink, includeDownload],
  );
  const rootClassName = clsx(classes.root, `${theme}-theme`);

  return (
    <div className={rootClassName}>
      {hasLogo && <img className={classes.logo} alt={logo?.altText} src={logo?.original?.url} />}
      <div className={classes.row}>
        {headline && (
          <div className={classes.col}>
            {headline && (
              <MuiTypography variant="h1" component="h1" className={classes.headline}>
                {headline}
              </MuiTypography>
            )}
          </div>
        )}
        {(shortDescription || primaryButton || hasDownloadLink) && (
          <div className={classes.col}>
            {shortDescription && (
              <CaptureClicksRichText
                content={shortDescription}
                containerProps={{ className: classes.description }}
                theme={theme}
              />
            )}
            {(primaryButton || hasDownloadLink) && (
              <div className={classes.buttons}>
                {primaryButton && (
                  <div>
                    <Button theme={theme} link={primaryButton} />
                  </div>
                )}
                {hasDownloadLink && (
                  <div>
                    <Button
                      outlined
                      link={{ href: downloadLink?.url }}
                      endIcon={downloadIcon ? <img alt="" src={downloadIcon} /> : <></>}
                      download
                      theme={theme}
                    >
                      {downloadText || 'Download'}
                    </Button>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(HeaderContent);
